import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

export async function GetHealthcareService(filter: string, value?: string) {
  const url = `${endpoints.WORKFLOWFHIR}/HealthcareService?${filter}=${value}&_count=250`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/fhir+json",
  };
  const response = await useAxios
    .get(url, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`Get HealthcareService: ${response.status}`);
      }
      return response.data;
    })
    .catch((error) => {
      console.error("GetHealthcareService ", error);
      // toast.error(`GetHealthcareService Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
